module.exports = __webpack_public_path__ + "media/images/proposal/top/reason5-a1aa5b09bac57667bd9374abecdfb964.jpg";